// The animated Akaiva logo shown wherever a screen waits for data. With reduced motion on (the
// phone's "Remove animations", or prefers-reduced-motion on the web) it shows the still logo.
import { Image } from "expo-image";
import { useEffect, useState } from "react";
import { AccessibilityInfo } from "react-native";

import STILL from "../../assets/akaiva-loader-static.png";
import ANIMATED from "../../assets/akaiva-loader.webp";

/** Logo artwork is 400 × 303. */
const ASPECT = 400 / 303;

function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    let live = true;
    AccessibilityInfo.isReduceMotionEnabled().then(
      (value) => live && setReduced(value),
      () => {},
    );
    // react-native-web returns nothing here when the browser lacks matchMedia.
    const sub: { remove(): void } | undefined =
      AccessibilityInfo.addEventListener("reduceMotionChanged", setReduced);
    return () => {
      live = false;
      sub?.remove();
    };
  }, []);
  return reduced;
}

export function BrandLoader({ width = 160 }: { width?: number }) {
  const reduced = useReducedMotion();
  return (
    <Image
      source={reduced ? STILL : ANIMATED}
      style={{ width, height: width / ASPECT }}
      contentFit="contain"
      autoplay={!reduced}
      accessible
      accessibilityRole="progressbar"
      accessibilityLabel="Loading"
      testID="brand-loader"
    />
  );
}
